export class ResetPasswordTokenNoValidoError extends Error {
    constructor() {
        super('Token para resetear clave no válido');
    }
}
